import moment from 'moment'

export function formatDate(valor, formato: string) {
    if (!valor) return null

    return moment(valor).format(formato)
}
